export default "__VITE_ASSET__CXX2COht__"